export const placeHolder = {
    privacyPolicyLink: 'PLACEHOLDER.PRIVACY_POLICY_LINK',
    termsOfServicesLink: 'PLACEHOLDER.TERMS_OF_SERVICES_LINK',
    workspaceTitle: 'PLACEHOLDER.WORKSPACE_TITLE',
    description: 'PLACEHOLDER.DESCRIPTION',
    enterCustomDomain: 'PLACEHOLDER.ENTER_CUSTOM_DOMAIN',
    enterWorkspaceHandle: 'PLACEHOLDER.ENTER_WORKSPACE_HANDLE',
    groupName: 'PLACEHOLDER.GROUP_NAME',
    memberEmail: 'PLACEHOLDER.MEMBER_EMAIL',
    search: 'PLACEHOLDER.SEARCH'
};
